/**
 * WHICH OF A TRIP'S SECTIONS START OPEN.
 *
 * Anthony, 2026-09-28: "fix the mobile and desktop experience on rentals
 * of the boxes like the trip, money, deposit hold. Put them one on top of
 * the other with a flyout option on all."
 *
 * The trip page is five sections stacked in one column, each folding shut
 * to a one line summary. Opening all five made the page the same wall of
 * fields it was, and opening none made every visit start with a tap. So
 * the lane decides: whatever this trip is waiting on is open, and the rest
 * is one tap away with its answer already in the head.
 *
 *   inquiry, quoted   the trip itself and what it costs
 *   booked            the money (the balance is next) and the pickup walk
 *   prep              the pickup walk round
 *   out, returning    the return walk round
 *   inspection        the return walk round and the deposit
 *   settled, closed,
 *   cancelled         the money, for the record
 *
 * Pure, so the rule is tested rather than read off the markup.
 */
import type { Stage } from "./rental.ts";

export type TripFold = "trip" | "money" | "deposit" | "pre" | "post";

const OPEN: Record<Stage, TripFold[]> = {
  inquiry: ["trip", "money"],
  quoted: ["trip", "money"],
  booked: ["money", "pre"],
  prep: ["pre"],
  out: ["post"],
  returning: ["post"],
  inspection: ["post", "deposit"],
  settled: ["money"],
  closed: ["money"],
  cancelled: ["money"],
};

/** The sections open when this trip's page is first drawn. */
export function openFolds(stage: Stage): TripFold[] {
  return OPEN[stage] ?? ["trip"];
}
